var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHtlTennisCourtOutlined = function SvgHtlTennisCourtOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.867 14a.49.49 0 0 1-.1 0A6 6 0 0 1 3.76 3.757 6 6 0 0 1 8.003 2h.2a.5.5 0 0 1 .155.007 6 6 0 0 1 3.885 10.236A6 6 0 0 1 8 14h-.133ZM7.4 9.276a5.8 5.8 0 0 1 .992 3.71 5.011 5.011 0 0 0 4.5-3.962 6.107 6.107 0 0 1-4.211-2.311 5.789 5.789 0 0 1-.989-3.7A5.012 5.012 0 0 0 3.11 6.951a6.159 6.159 0 0 1 4.29 2.324l.002.001ZM3 8a5.01 5.01 0 0 0 4.391 4.963 4.857 4.857 0 0 0-.806-3.112 5.2 5.2 0 0 0-3.584-1.909L3 8Zm6.5-1.864A5.134 5.134 0 0 0 13 8.027V8a5.01 5.01 0 0 0-4.3-4.952 4.84 4.84 0 0 0 .8 3.088Z"
  })));
};
export default SvgHtlTennisCourtOutlined;